<template>
    <click-to-edit
      v-model="value.performance_formula_id"
      type="select"
      placeholder=""
      :disabled="disabled"
      select-filterable
      :select-options="formulas"
      select-option-id="id"
      select-option-name="name"
      select-option-icon="icon"
      select-option-icon-base-path="/img/performanceFormulas/"
      select-cast-value-to-int
      @opened="loadFormulas"
      @input="changed"
    >
    </click-to-edit>
</template>

<script>
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "PerformanceFormulaSelect",
  components: {ClickToEdit},
  props: {
    value: {}, // whole element
    disabled: {type: Boolean, default: false},
  },

  watch: {},
  mounted() {
    if( this.value?.performance_formula ){
      this.formulas.push(this.value.performance_formula);
    }
  },
  data() {
    return {
      formulas: [],
    }
  },
  methods: {
    loadFormulas() {
      this.$api.cascading.getPerformanceFormulas()
        .then(data => {
          this.formulas = data.formulas;
        })
    },
    changed() {
      this.$emit('input', this.value);
      this.$emit('change', this.value)
    }
  },

}
</script>
